import { render, staticRenderFns } from "./ThirdTab.vue?vue&type=template&id=563feac1&scoped=true"
import script from "./ThirdTab.vue?vue&type=script&lang=js"
export * from "./ThirdTab.vue?vue&type=script&lang=js"
import style0 from "./ThirdTab.vue?vue&type=style&index=0&id=563feac1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563feac1",
  null
  
)

export default component.exports